import React from 'react'
import { Box, Container, Typography, Button } from '@mui/material'
import { useTranslations } from 'next-intl'

const MobileAppPromotion: React.FC = () => {
    const t = useTranslations('homePage.mobileApp')
    
    return (
        <Box sx={{ 
            bgcolor: '#f5f7fa',
            mt: { xs: 4, sm: 6 }, 
            mb: { xs: 4, sm: 6 },
            py: { xs: 4, sm: 6, md: 8 },
            display: { xs: 'none', sm: 'none', md: 'block' }
        }}>
            <Container maxWidth="xl">
                {/* Mobile App Promotional Banner */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, rgb(67, 129, 205) 0%, rgb(25, 77, 145) 100%)',
                        borderRadius: 2,
                        position: 'relative',
                        overflow: 'hidden',
                        py: { xs: 3, sm: 4, md: 5 },
                        px: { xs: 3, sm: 4, md: 6 }
                    }}
                >
                <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        textAlign: 'center',
                        minHeight: 180 
                    }}>
                        {/* Text Content - Centered */}
                        <Box sx={{ 
                            width: '100%',
                            mb: 4
                        }}>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            color: 'white',
                                            fontWeight: 'bold',
                                            mb: 2,
                                            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }
                                        }}
                                    >
                                        {t('title')}
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: 'white',
                                            mb: 4,
                                            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                                            opacity: 0.9
                                        }}
                                    >
                                        {t('subtitle')}
                                    </Typography>

                            {/* App Download Buttons */}
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                                {/* Google Play Button */}
                                <Button
                                    href="https://play.google.com/store/apps/details?id=com.flyin.bookings"
                                    target="_blank"
                                    className="android"
                                    sx={{
                                        backgroundColor: 'white',
                                        color: 'black',
                                        px: 4,
                                        py: 2,
                                        borderRadius: 1,
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '0.9rem',
                                        minWidth: 180,
                                        height: 60,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f8f9fa'
                                        },
                                        '&::before': {
                                            content: '""',
                                            display: 'inline-block',
                                            height: '44px',
                                            width: '100%',
                                            background: 'url(https://me.flyin.com/common/themes/v2/img/appBtnSprite.png) -144px -63px / 320px no-repeat',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '55%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 1
                                        }
                                    }}
                                >
                                    <Box sx={{ 
                                        position: 'relative', 
                                        zIndex: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '100%',
                                        height: '100%'
                                    }}>
                                        {/* Sprite icon contains all text, no extra text needed */}
                                    </Box>
                                </Button>

                                {/* App Store Button */}
                                <Button
                                    href="https://itunes.apple.com/us/app/flyin.com-tyran-w-fnadq/id1106268318"
                                    target="_blank"
                                    className="ios"
                                    sx={{
                                        backgroundColor: 'white',
                                        color: 'black',
                                        px: 4,
                                        py: 2,
                                        borderRadius: 1,
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '0.9rem',
                                        minWidth: 180,
                                        height: 60,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        position: 'relative',
                                        '&:hover': {
                                            backgroundColor: '#f8f9fa'
                                        },
                                        '&::before': {
                                            content: '""',
                                            display: 'inline-block',
                                            height: '44px',
                                            width: '100%',
                                            background: 'url(https://me.flyin.com/common/themes/v2/img/appBtnSprite.png) -135px -9px / 320px no-repeat',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 1
                                        }
                                    }}
                                >
                                    <Box sx={{ 
                                        position: 'relative', 
                                        zIndex: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '100%',
                                        height: '100%'
                                    }}>
                                        {/* Sprite icon contains all text, no extra text needed */}
                                    </Box>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Container>
                </Box>
            </Container>

            {/* Feature Highlights */}
            <Container maxWidth="lg" sx={{ mt: { xs: 6, sm: 8 } }}>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', md: 'row' }, 
                    gap: 4,
                    justifyContent: 'space-between'
                }}>
                    {/* Feature 1: Easy & Fast Booking */}
                    <Box sx={{ textAlign: 'center', p: 3, flex: 1 }}>
                        <Box
                            sx={{
                                width: 55,
                                height: 55,
                                backgroundImage: 'url(https://me.flyin.com/common/themes/v2/img/sprite.png)',
                                backgroundPosition: '-297px -192px',
                                backgroundSize: '500px',
                                margin: '0 auto 16px',
                                borderRadius: 1
                            }}
                        />
                               <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1f2937' }}>
                                   {t('features.easyBooking.title')}
                               </Typography>
                               <Typography variant="body1" sx={{ color: '#6b7280', lineHeight: 1.6 }}>
                                   {t('features.easyBooking.description')}
                               </Typography>
                    </Box>

                    {/* Feature 2: Multi Payment Option */}
                    <Box sx={{ textAlign: 'center', p: 3, flex: 1 }}>
                        <Box
                            sx={{
                                width: 55,
                                height: 55,
                                backgroundImage: 'url(https://me.flyin.com/common/themes/v2/img/sprite.png)',
                                backgroundPosition: '-312px -159px',
                                backgroundSize: '421px',
                                margin: '0 auto 16px',
                                borderRadius: 1
                            }}
                        />
                               <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1f2937' }}>
                                   {t('features.multiPayment.title')}
                               </Typography>
                               <Typography variant="body1" sx={{ color: '#6b7280', lineHeight: 1.6, mb: 2 }}>
                                   {t('features.multiPayment.description')}
                               </Typography>
                        {/* Payment Logos */}
                        <Box
                            component="img"
                            src="https://me.flyin.com/common/themes/v2/img/secure-payment.png"
                            alt="Payment Methods"
                            sx={{ height: 30, maxWidth: '100%' }}
                        />
                    </Box>

                    {/* Feature 3: 24/7 Customer Support */}
                    <Box sx={{ textAlign: 'center', p: 3, flex: 1 }}>
                        <Box
                            sx={{
                                width: 55,
                                height: 55,
                                backgroundImage: 'url(https://me.flyin.com/common/themes/v2/img/sprite.png)',
                                backgroundPosition: '-442px -192px',
                                backgroundSize: '500px',
                                margin: '0 auto 16px',
                                borderRadius: 1
                            }}
                        />
                               <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1f2937' }}>
                                   {t('features.customerSupport.title')}
                               </Typography>
                               <Typography variant="body1" sx={{ color: '#6b7280', lineHeight: 1.6 }}>
                                   {t('features.customerSupport.description')}
                               </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export { MobileAppPromotion }
export type { MobileAppPromotionProps }

interface MobileAppPromotionProps {
    // Props interface for future extensibility
}
